module.exports = __webpack_public_path__ + "img/67743625000467.88668b76.png";